<template>
    <section class="slider">
        <div class="container">
            <div class="slider-track">
                <div
                    class="slider-track-inner"
                    :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
                >
                    <article
                        class="slide"
                        v-for="(s, i) in normalizedSlides"
                        :key="i"
                        :style="slideBgStyle(s)"
                        :aria-hidden="i !== currentIndex"
                    >
                        <div class="slide-inner">
                            <div class="row align-items-center g-4">
                                <!-- left: content -->
                                <div class="col-12 col-lg-6">
                                    <div class="slide-content">
                                        <div class="slide-kicker">{{ s.kicker }}</div>
                                        <h2 class="slide-title" v-html="s.title"></h2>
                                        <p class="slide-text">{{ s.text }}</p>



                                        <div class="slide-tags" v-if="s.tags && s.tags.length">
                                            <span class="slide-tag" v-for="(t, k) in s.tags" :key="k">{{ t }}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- right: image -->
                                <div class="col-12 col-lg-6">
                                    <div class="slide-media">
                                        <img
                                            v-if="s.image"
                                            class="slide-image"
                                            :src="s.image"
                                            :alt="s.imageAlt || ''"
                                            loading="lazy"
                                            decoding="async"
                                        />
                                    </div>
                                </div>
                            </div>

                            <!-- dots -->
                            <div class="slider-dots" role="tablist" aria-label="Слайды">
                                <button
                                    v-for="(_, d) in normalizedSlides"
                                    :key="d"
                                    class="slider-dot"
                                    :class="{ 'is-active': d === currentIndex }"
                                    @click="goTo(d)"
                                    type="button"
                                    :aria-label="`Слайд ${d + 1}`"
                                />
                            </div>

                            <!-- arrows -->
                            <div class="slider-nav">
                                <button class="slider-btn" type="button" @click="prevSlide" aria-label="Предыдущий">
                                    &#10094;
                                </button>
                                <button class="slider-btn" type="button" @click="nextSlide" aria-label="Следующий">
                                    &#10095;
                                </button>
                            </div>
                        </div>
                    </article>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "Slider",
    props: {
        slides: { type: Array, required: false, default: () => [] }
    },
    data() {
        return { currentIndex: 0 };
    },
    computed: {
        normalizedSlides() {
            const base = [
                {
                    kicker: "Мониторинг",
                    title: "Держим бренд<br>в безопасной зоне",
                    text: "Отслеживаем упоминания и выдачу, собираем метрики, делаем отчёты и реагируем быстро.",
                    tags: ["Аналитика", "Упоминания", "Отчёты"],
                    primary: { label: "Запросить аудит", href: "#" },
                    secondary: { label: "Пример отчёта", href: "#" },
                    bg: "/img/slider/slider-bg-monitoring.png",
                    image: "/img/slider/slider-ill-monitoring.png",
                    imageAlt: ""
                },
                {
                    kicker: "Удаление негатива",
                    title: "Снимаем негатив<br>без риска для бренда",
                    text: "Легальные механики: фиксация, претензии, переговоры и сопровождение — без самодеятельности.",
                    tags: ["Отзывы", "Статьи", "Страницы"],
                    primary: { label: "Оценить задачу", href: "#" },
                    secondary: { label: "Как работаем", href: "#" },
                    bg: "/img/slider/slider-bg-monitoring.png",
                    image: "/img/slider/slider-ill-removal.png",
                    imageAlt: ""
                },
                {
                    kicker: "Медиация",
                    title: "Возвращаем диалог<br>в конструктив",
                    text: "Сценарии общения + юридические формулировки: гасим конфликт до публичной стадии и фиксируем итог.",
                    tags: ["Переговоры", "Претензии", "PR+Legal"],
                    primary: { label: "Получить сценарий", href: "#" },
                    secondary: { label: "Подробнее", href: "#" },
                    bg: "/img/slider/slider-bg-monitoring.png",
                    image: "/img/slider/slider-ill-mediation.png",
                    imageAlt: ""
                },
                {
                    kicker: "Журнал",
                    title: "Кейсы и практика<br>по защите репутации",
                    text: "Разборы атак, судебных решений и площадок: что делать, когда на бренд давят — и как выходить сильнее.",
                    tags: ["ORM", "Суды", "Площадки"],
                    primary: { label: "Читать", href: "#" },
                    secondary: { label: "Все материалы", href: "#" },
                    bg: "/img/slider/slider-bg-monitoring.png",
                    image: "/img/slider/slider-ill-journal.png",
                    imageAlt: ""
                }
            ];

            return this.slides && this.slides.length ? this.slides : base;
        }
    },
    methods: {
        slideBgStyle(slide) {
            if (!slide || !slide.bg) return {};
            return { backgroundImage: `url('${slide.bg}')` };
        },
        nextSlide() {
            this.currentIndex = (this.currentIndex + 1) % this.normalizedSlides.length;
        },
        prevSlide() {
            this.currentIndex =
                (this.currentIndex - 1 + this.normalizedSlides.length) % this.normalizedSlides.length;
        },
        goTo(i) {
            this.currentIndex = i;
        }
    }
};
</script>